import { DatalayerHelper } from './ib-datalayer-helper';
import * as ancillariesInfo   from '../core/models/ancillaries-info';

@Service('ib-web-ancillaries-module',
    ['CommonsUtilService', 'DatalayerHelper', 'localStorageService', 'DatalayerUtilsService', 'AncillariesConstants'],
    ['ib-commons-constants-module', 'ib-monetate-module'])
export class PriorityDatalayerUtils {
    seatSelectedId: string[] = [];
    seatSelectedType: string[] = [];
    segmentId: string;
    constructor (
        private CommonsUtilService: CommonsUtilService,
        private DatalayerHelper: DatalayerHelper,
        private localStorageService: angular.local.storage.ILocalStorageService,
        private DatalayerUtilsService: DatalayerUtilsService,
        private AncillariesConstants: AncillariesConstant
    ) { }

    getDataEcommerceForPriorityBoarding (segment) {
        const id = this.CommonsUtilService.getIdItem('all');
        const selectedTripInfo: any = this.localStorageService.get('selectedTripInfo');
        const itemCategory2: string = this.DatalayerUtilsService.getItemCategory2(this.CommonsUtilService.getSliceById(segment?.id));
        const item: DigitalDataEcommerceModel.Item = {
            item_name: this.AncillariesConstants.DATALAYER_INFO.PRIORITY_BOARDING,
            item_id: id,
            price: segment?.passengers[0].amount,
            item_brand: selectedTripInfo ? selectedTripInfo[0].info.segments[0].flight.operationalCarrier.name.toLowerCase() : this.DatalayerHelper.getBrandItem(id, null),
            item_category: this.DatalayerHelper.getItemCategory(),
            item_category2: itemCategory2,
            item_category3: this.DatalayerUtilsService.getItemCategory3(this.AncillariesConstants.DATALAYER_INFO.PRIORITY_BOARDING, itemCategory2, id),
            item_variant: ''
        };
        return item;
    }

    setPriorityBoardingSelectItem = (tripInfo: any) => {
        const selectedTripInfo: any = this.localStorageService.get('selectedTripInfo');
        const id = this.CommonsUtilService.getIdItem('all');
        const itemCategory2: string = this.DatalayerUtilsService.getItemCategory2(this.CommonsUtilService.getSliceById(tripInfo?.id));
        const item: DigitalDataEcommerceModel.Item = {
            item_name: this.AncillariesConstants.DATALAYER_INFO.PRIORITY_BOARDING,
            item_id: id,
            price: tripInfo.amount,
            item_brand: selectedTripInfo ? selectedTripInfo[0].info.segments[0].flight.operationalCarrier.name.toLowerCase() : this.DatalayerHelper.getBrandItem(itemCategory2, null),
            item_category: this.DatalayerHelper.getItemCategory(),
            item_category2: itemCategory2,
            item_category3: this.DatalayerUtilsService.getItemCategory3(this.AncillariesConstants.DATALAYER_INFO.PRIORITY_BOARDING, itemCategory2, id),
            item_variant: '',
            quantity: tripInfo.numPassengers === 0 ? 1 : tripInfo.numPassengers
        };
        return item;
    };

    setPriorityBoardingAddToCart = (segments: any, info: any) => {
        const digital_data_ecommerce: DigitalDataEcommerceModel.ViewItemList = { items: [] };
        const selectedTripInfo: any = this.localStorageService.get('selectedTripInfo');
        const id = this.CommonsUtilService.getIdItem('all');
        let itemsToRemove: DigitalDataEcommerceModel.ViewItemList = { items: [] };
        const addToCart: DigitalDataEcommerceModel.ViewItemList = this.DatalayerHelper.getItemAddToCartByItemName(this.AncillariesConstants.DATALAYER_INFO.PRIORITY_BOARDING);
        segments.forEach(segment => {
            info[0].trips.forEach(trip => {
                if (segment.id === trip.id && trip.checkedTrip) {
                    const itemCategory2: string = this.DatalayerUtilsService.getItemCategory2(this.CommonsUtilService.getSliceById(trip?.id));
                    const item: DigitalDataEcommerceModel.Item = {
                        item_name: this.AncillariesConstants.DATALAYER_INFO.PRIORITY_BOARDING,
                        item_id: id,
                        price: trip.amount,
                        item_brand: selectedTripInfo ? selectedTripInfo[0].info.segments[0].flight.operationalCarrier.name.toLowerCase() : this.DatalayerHelper.getBrandItem(itemCategory2, null),
                        item_category: this.DatalayerHelper.getItemCategory(),
                        item_category2: itemCategory2,
                        item_category3: this.DatalayerUtilsService.getItemCategory3(this.AncillariesConstants.DATALAYER_INFO.PRIORITY_BOARDING, itemCategory2, id),
                        item_variant: '',
                        quantity: (segment?.passengerIds?.length > 0) ? segment.passengerIds.length : 1
                    };
                    digital_data_ecommerce.items.push(item);
                }
            });
        });
        itemsToRemove = this.DatalayerHelper.getItemsToAddOrRemove(addToCart, digital_data_ecommerce, false);
        return {digital_data_ecommerce, itemsToRemove};
    };
}

